import Vue from 'vue';
import Router from 'vue-router';
import _fuc from '../utils/config.js'
// 添加微信公众号授权的逻辑
import wechatAuth from '../utils/wechatAuth';

import axios from "@/utils/request";
Vue.prototype.$axios = axios;
Vue.use(Router);
// 解决重复点击导航路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}

import Userinfo from './userinfo';
import Yzjc from './yzjc';
import Tsbx from './tsbx';
import Wyfw from './wyfw';
const routes = [
	...Userinfo.routes, //个人中心的路由
	...Yzjc.routes, //业主决策的路由
	...Tsbx.routes, //投诉报修的路由
	...Wyfw.routes, //物业服务的路由
	{
		path: '/',
		redirect: '/home'
	},
	{
		name: 'smrz',
		component: () => import('../view/smrz'),
		meta: {
			title: '填写用户信息',
			head: false,
			headReturn: false,
			tabbar: false
		}
	},
	{
		name: 'bdfw',
		component: () => import('../view/bdfw'),
		meta: {
			title: '绑定房屋',
			head: false,
			headReturn: false,
			tabbar: false
		}
	},
	{
		name: 'wuye',
		component: () => import('../view/wuye'),
		meta: {
			title: '物业登录',
			head: false,
			headReturn: false,
			tabbar: false
		}
	},
	{
		name: 'index-wuye',
		component: () => import('../view/index-wuye'),
		meta: {
			title: '物业首页',
			head: false,
			headReturn: false,
			tabbar: false
		}
	},
	{
		name: 'bdxq',
		component: () => import('../view/bdxq'),
		meta: {
			title: '绑定小区',
			head: false,
			headReturn: false,
			tabbar: false
		}
	},
	// 通用列表页
	{
		name: 'commonlist',
		path: '/common/list/:columnId',
		component: () => import('../view/common/list'),
		meta: {
			title: '',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	// 通用详情页
	{
		name: 'commondetail',
		path: '/common/detail/:columnId',
		component: () => import('../view/common/detail'),
		meta: {
			title: '',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'home',
		component: () => import('../view/index-new.vue'),
		meta: {
			title: '首页',
			keepAlive:false,
			head: false,
			headReturn: false,
			tabbar: true
		}
	},
	{
		name: 'lbxq',
		path: '/lbxq',
		component: () => import('../view/banner.vue'),
		meta: {
			title: '文章详情',
			keepAlive:false,
			head: true,
			headReturn: true,
			tabbar: true
		}
	},
	{
		name: 'bmfw',
		path: '/bmfw',
		component: () => import('../view/bmfw'),
		meta: {
			title: '便民服务',
			keepAlive:true,
			head: false,
			headReturn: false,
			tabbar: true
		}
	},{
		name: 'wuzi',
		path: '/wuzi',
		component: () => import('../view/wuzi.vue'),
		meta: {
			title: '封控小区住户生活物资应急保障需求表',
			keepAlive:false,
			head: true,
			headReturn: true,
			tabbar: false
		}
	},{
		name: 'wuzinew',
		path: '/wuzinew',
		component: () => import('../view/wuzi2.vue'),
		meta: {
			title: '封控小区住户生活物资应急保障需求表',
			keepAlive:false,
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'user',
		component: () => import('../view/user/index'),
		meta: {
			title: '个人中心',
			keepAlive:true,
			head: false,
			headReturn: false,
			tabbar: true
		}
	},
	{
		// 这个页面不用了
		name: 'zbdy',
		path: '/hsyw/zbdy',
		component: () => import('../view/hsyw/zbdy'),
		meta: {
			title: '支部党员',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'dzbdetail',
		path: '/hsyw/dzbdetail',
		component: () => import('../view/hsyw/dzbdetail'),
		meta: {
			title: '小区党支部详情',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'dzbdetail',
		path: '/djindex',
		component: () => import('../view/dangjianindex.vue'),
		meta: {
			title: '小区党支部',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'zhzfz',
		path: '/zhzfz',
		component: () => import('../view/zhzfzlist.vue'),
		meta: {
			title: '联动执法工作站',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
	{
		name: 'zhzfzxq',
		path: '/zhzfz/xq',
		component: () => import('../view/zhzfz.vue'),
		meta: {
			title: '联动执法工作站',
			head: true,
			headReturn: true,
			tabbar: false
		}
	},
];

// 有path就取path，没有就拼接'/' +name
routes.forEach(route => {
	route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
	routes
});

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

// 正式环境有了域名后，获取token等信息用来代替openId用，2小时内有效，一直用，一直有效;10002：token失效或已过期
function getSign2() {
	return new Promise((resolve, reject) => {
		let theCode = getQueryString('code');
		if (theCode) {
			axios({
				method: "get",
				url: "/api/v2/wechat/user/codeSession/" + theCode,
				params: {}
			}).then(res => {
				_fuc.setToken(res.token)
				_fuc.setIdentity(res.userInfo.level);
				// 0未认证  2：房主认证  20：待审核 
				let realUrl = window.location.href.split("?")[0];
				window.location.href = realUrl;
			});
		} else if (_fuc.getToken() == null) {
			var type=getQueryString('type');
			var id=getQueryString('id');
			if(type){
				//直接打开决策投票详情页、维修金使用投票详情页
				_fuc.setItem('type',type);
				_fuc.setItem('id',id);
			}
			wechatAuth.redirectUri = window.location.href;
			window.location.href = wechatAuth.authUrl
		} else {
			// 获取完token后
			resolve()
		}

	})
}
// 本地模拟正式环境逻辑
function getSign() {
	return new Promise((resolve, reject) => {
		// let theCode = 'test_oNlETwkUVErKN3JVoMsUBB8X6T0o';
		let theCode = 'test_oGWZS6dIoxV9OXfbcArgjtDul8k0';
		sessionStorage.setItem('code',theCode)
		//test123456, test1234561,test1234562
		//本地测试修改code后sessionStorage.clear()一下，或者关闭页面后重进
		if (_fuc.getToken() == null || sessionStorage.getItem('istokenwork') == 0) {
			console.log('未有token')
			axios({
				method: "get",
				url: "/api/v2/wechat/user/codeSession/" + theCode,
				params: {}
			}).then(res => {
				console.log(res)
				var type=getQueryString('type');
				var id=getQueryString('id');
				if(type){
					//直接打开决策投票详情页、维修金使用投票详情页
					_fuc.setItem('type',type);
					_fuc.setItem('id',id);
				}
				var level=res.userInfo.level;
				if(level===''){
					alert("接口返回的level不对")
				}else{
					_fuc.setIdentity(res.userInfo.level)
					_fuc.setToken(res.token);
					window.location.reload()
				}
				// 0未认证  2：房主认证  20：待审核 
			});
		} else {
			// 获取完token后
			resolve()
		}
	})
}
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
	var temp;
	if (process.env.NODE_ENV == "production") {
		temp=getSign2()
	} else if (process.env.NODE_ENV == "development") {
		temp=getSign()
	} 
	temp.then(res => {
		next()
	})
});

export{
	router,
	getSign,
	getSign2,
};
